/**
 * Module Manifest Registry
 *
 * Singleton registry that maps module keys to their TypeScript manifests and
 * optional rules engines. Follows the same pattern as FieldResolverRegistry
 * in vendor/ui-components.
 *
 * Usage:
 *   // At bootstrap (apps/console/src/bootstrap.ts)
 *   moduleManifestRegistry.register(technicalSheetManifest, technicalSheetRules);
 *
 *   // At runtime
 *   const manifest = moduleManifestRegistry.getManifest('technicalSheet');
 *   const rules = moduleManifestRegistry.getRules('technicalSheet');
 */
class ModuleManifestRegistry {
    constructor() {
        this.manifests = new Map();
        this.rules = new Map();
    }
    /**
     * Registers a manifest and optional rules engine.
     * The manifest key must match Module.actionProperties.redirectTo.
     */
    register(manifest, rules) {
        this.manifests.set(manifest.key, manifest);
        if (rules) {
            this.rules.set(manifest.key, rules);
        }
    }
    /**
     * Returns the manifest for the given key, or undefined if not registered.
     * Key matches Module.actionProperties.redirectTo (e.g. 'technicalSheet').
     */
    getManifest(key) {
        return this.manifests.get(key);
    }
    /**
     * Returns the rules engine for the given key, or undefined if not registered.
     */
    getRules(key) {
        return this.rules.get(key);
    }
    /**
     * Returns all registered manifest keys.
     */
    getAllKeys() {
        return Array.from(this.manifests.keys());
    }
    /**
     * Returns true if a manifest is registered for the given key.
     * Use this to conditionally show a "Configure Parameters" button.
     */
    isRegistered(key) {
        return this.manifests.has(key);
    }
}
export const moduleManifestRegistry = new ModuleManifestRegistry();
//# sourceMappingURL=moduleManifestRegistry.js.map